import {
  REQUESTED_SUBMIT_NOTIFICATION,
  RECEIVED_SUBMIT_NOTIFICATION,
  ERROR_SUBMIT_NOTIFICATION
} from 'state/submitNotification/SubmitNotificationActions';

export const submitRequestStatusReducer = (state = null, action) => {
  const { type } = action;

  if(type === REQUESTED_SUBMIT_NOTIFICATION) {
    return 'REQUESTED';
  }

  if(type === RECEIVED_SUBMIT_NOTIFICATION) {
    return 'RECEIVED';
  }

  if(type === ERROR_SUBMIT_NOTIFICATION) {
    return 'ERROR';
  }

  return state;
};

export const schedulingLinkReducer = (state = null, action) => {
  const { type } = action;
  if(type === RECEIVED_SUBMIT_NOTIFICATION) {
    const { response } = action;

    if(response && response.schedulingLink) {
      return response.schedulingLink;
    }
  }

  return state;
};

export const caseNumberReducer = (state = null, action) => {
  const { type } = action;
  if(type === RECEIVED_SUBMIT_NOTIFICATION) {
    const { response } = action;

    if(response && response.caseNumber) {
      return response.caseNumber;
    }
  }

  return state;
};
